import React from "react";

type Props = { children?: React.ReactNode };

const ReportActionSection = ({ children }: Props) => {
  return (
    <div className="absolute flex items-center right-2 -top-12">{children}</div>
  );
};

export default ReportActionSection;
